import { Component, Injector, OnInit } from '@angular/core';
import { AuthorizationScheme, AuthorizationSchemeService, createDtoProperties, DtoComponent } from '@mango/core';
import { User } from './user';
import { UserService } from './user.service';


@Component({
    selector: 'app-user',
    templateUrl: './user.component.html',
    styleUrls: ['./user.component.css']
})
export class UserComponent extends DtoComponent<User> implements OnInit {
    properties = createDtoProperties<User>([
        "firstName",
        "lastName",
        "email",
        "locked",        
        "lastPasswordChanged",
        "mfaEnabled",
        "isMfaExempt",
        "archivedOn"
    ]);

    myScheme: AuthorizationScheme;
    
    constructor(private userService: UserService, injector: Injector, private authService: AuthorizationSchemeService) {
        super(injector, userService, User);
    }

    ngOnInit() {
        super.ngOnInit();
        this.myScheme = this.authService.getMyScheme();
        this.setCustomActions();

        this.handleRoute("id");
    }

    canDelete(){
        return false;
    }

    isArchived() {
        return (this.item.archivedOn != null);
    }

    canCreate(type: string) {
        return this.myScheme.canCreate(type);
    }

    private setCustomActions() {
        this.buildCustomActions(config => config.add({
            icon: "lock_outline",
            name: "Stuur activatie code",
            fn: () => {
                this.dialogs.confirm("Stuur activatie code", `Hiermee stuurt u een activatie code naar ${this.item.firstName} ${this.item.lastName}, waarmee hij of zij het account kan activeren om vervolgens in te loggen.\n\nWeet u zeker dat u wilt doorgaan?`)
                    .then(ok => {
                        if (ok) {
                            this.userService.sendActivationCode(this.item.id).toPromise()
                                .then(ok => {
                                    if (ok && ok.successfull) {
                                        this.dialogs.alert("Verzonden", "De activatie code is verzonden.", "info_outline");
                                    }
                                    else {
                                        this.dialogs.alert("Fout", "Er is een fout opgetreden, probeer het later nog een keer.", "warning");
                                    }
                                });
                        }
                    });
            },
            isEnabled: () => !this.isNewItem
        }));
    }
}
